import checkPartnerCooperationAgreementStatus from "@/shared/router/guards/checkPartnerCooperationAgreementStatus";
import checkPartnerType from "@/shared/router/guards/checkPartnerType";

export default {
  default: [
    {
      path: "/dashboard",
      name: "dashboard",
      beforeEnter: checkPartnerType
    },
    {
      path: "/spaarder",
      name: "funders.table",
      component: () => import("./views/FunderTableView.vue"),
      beforeEnter: checkPartnerCooperationAgreementStatus
    },
    {
      path: "/spaarder/aanmaken",
      name: "funders.create",
      component: () => import("./views/FunderFormView.vue"),
      beforeEnter: checkPartnerCooperationAgreementStatus
    },
    {
      path: "/spaarder/:id",
      name: "funders.view",
      component: () => import("./views/FunderDetailsView.vue"),
      redirect: { name: "funders.view.contracts" },
      beforeEnter: checkPartnerCooperationAgreementStatus,
      children: [
        {
          path: "contracten",
          name: "funders.view.contracts",
          component: () => import("./views/FunderDetails/ContractsView.vue")
        },
        {
          path: "accounts/:accountId",
          name: "funders.view.accounts.view",
          component: () => import("./views/FunderDetails/AccountView.vue")
        },
        {
          path: "accounts",
          name: "funders.view.accounts",
          component: () => import("./views/FunderDetails/AccountsView.vue")
        },
        {
          path: "details",
          name: "funders.view.details",
          component: () => import("./views/FunderDetails/DetailsView.vue")
        }
      ]
    },
    {
      path: "/spaarder/:id/wijzigen",
      name: "funders.edit",
      component: () => import("./views/FunderFormView.vue"),
      beforeEnter: checkPartnerCooperationAgreementStatus
    },
    {
      path: "/geen-contract",
      name: "funders.noAgreement",
      component: () => import("@/shared/views/NoPartnerCooperationAgreementView.vue")
    }
  ]
};
